import { tw } from "@sveabank/cc-common";
import type { ReactNode } from "react";

type Props = {
	children: ReactNode;
	size?: keyof typeof basis;
	my?: keyof typeof margins;
	py?: keyof typeof paddings;
};

const margins = {
	0: tw`tablet:my-0`,
	4: tw`tablet:my-4`,
	8: tw`tablet:my-8`,
};

const paddings = {
	0: tw`py-0`,
	4: tw`py-4`,
	8: tw`tablet:py-8 py-4`,
};

const basis = {
	2: tw`tablet:w-2/12`,
	3: tw`tablet:w-3/12`,
	4: tw`tablet:w-4/12`,
	6: tw`tablet:w-6/12`,
	8: tw`tablet:w-8/12`,
	9: tw`tablet:w-9/12`,
	10: tw`tablet:w-10/12`,
	12: tw`tablet:w-full`,
};

const Content = ({ children, size = 12, my = 0, py = 0 }: Props) => (
	<div className={tw("mx-auto w-full", basis[size], margins[my], paddings[py])}>{children}</div>
);

export default Content;
